<template>
  <draggable
    :list="widgets"
    item-key="name"
    @end="emitData"
  >
    <template #item="{element}">
      <div class="button-block">
        <div class="button-block__title">
          <el-icon :size="15" class="button-block__title-icon">
            <DCaret />
          </el-icon>
          {{ titleProxy(element) || '???' }}
          <el-tooltip
            v-if="element.name === 'telegram'"
            placement="top"
            :content="translateText('hubstr.editor.modal.hint_telegram')"
          >
            <el-icon :size="15" color="#007AFF" class="button-block__tooltip">
              <Question />
            </el-icon>
          </el-tooltip>
        </div>
        <div class="button-block__check">
          <el-switch
            v-model="element.visible"
            size="small"
            @change="emitData"
          />
        </div>
      </div>
    </template>
  </draggable>
</template>

<script lang="ts" setup>
import {
  computed,
  reactive, watch,
} from 'vue';
import Draggable from 'vuedraggable-es';
import { DCaret } from '@element-plus/icons-vue';
import { TranslatesList as t } from 'features/settings/editor/residents-editor/requests';
import Question from 'features/settings/editor/assets/icons/question.svg';
import { translate, useTranslate } from 'magner';

interface Props {
  data: any;
}

const props = defineProps<Props>();
const emit = defineEmits(['update:data']);

const state = reactive(props.data);

const widgets = reactive([
  {
    type: 'list_line_widget',
    leftText: 'lang.email',
    rightIcon: 'next',
    rightText: 'data.contacts.email',
    name: 'email',
    visible: false,
  },
  {
    hasPrivacy: true,
    infoText: 'lang.phone_visibility',
    isShow: 'data.hidePhone',
    name: 'phone',
    text: 'data.contacts.phone',
    title: 'lang.phone',
    type: 'info_line_action_widget',
    visible: false,
  },
  {
    leftIcon: null,
    leftText: 'lang.telegram',
    name: 'telegram',
    rightIcon: 'next',
    rightText: 'data.contacts.telegram',
    type: 'list_line_widget',
    visible: false,
  },
  {
    leftText: 'lang.userOtherSocials',
    name: 'site',
    rightIcon: 'next',
    rightText: 'data.additions.userOtherSocials',
    type: 'list_line_widget',
    visible: false,
  },
]);

const titleProxy = (widget: any) => {
  if ('leftText' in widget) {
    return t[(widget.leftText.replace('lang.', ''))];
  }

  return t[(widget.title?.replace('lang.', ''))];
};

watch(() => props.data, () => {
  const visibleButtons = props.data.widgets?.map((w) => (w.name));
  widgets.map((i) => {
    i.visible = visibleButtons.includes(i.name);
    return i;
  });
}, { deep: true, immediate: true });

const emitData = () => {
  const out = widgets.filter((i) => i.visible).map(({ visible, ...w }) => w);

  emit('update:data', out);
};

const { customT } = useTranslate();
const translateText = (code: string) => customT(translate(code));
</script>

<style scoped>
.button-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: var(--el-box-shadow-lighter);
  padding: 10px 20px;
  border-radius: var(--el-card-border-radius);
  margin-bottom: 10px;

  &__title {
    display: flex;
    align-items: center;
  }
  &__title-icon {
    cursor: move;
    margin-right: 5px;
  }
  &__tooltip {
    margin-left: 5px;
  }
}
</style>
